import { useState } from 'react';

import { useSession } from '@/api/session';

/**
 * Ending a session.
 *
 * `signOut` existed in the session context from the beginning and nothing ever
 * called it, so the console had no way out: the only thing that ended a session
 * was the thirty-minute idle timeout. On a shared agency workstation that is
 * the difference between a coordinator leaving the desk and a coordinator
 * leaving their account open on it — which is the scenario automatic logoff
 * exists to limit, not to replace.
 */
export function SignOutButton({ subtle = false }: { subtle?: boolean }) {
  const { user, signOut } = useSession();
  const [busy, setBusy] = useState(false);

  if (!user) return null;

  return (
    <button
      type="button"
      className={subtle ? 'signout signout--subtle' : 'signout'}
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await signOut();
        } finally {
          // Back to a clean page rather than a half-torn-down one: any cached
          // route state belongs to a session that no longer exists.
          window.location.href = '/';
        }
      }}
    >
      {busy ? 'Signing out…' : 'Sign out'}
    </button>
  );
}
